import { ConfirmationService } from 'primeng/api';
import { Component, OnInit, ViewChildren, QueryList, ViewChild, Input } from '@angular/core';
import { ItemConfirmComponent } from '@pages/_components/item-confirm/item-confirm.component';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { Table } from 'primeng/table';
import { TabPanelHandler } from '@core/_utils/table.utils';
import { CommonService } from '@service/common.service';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, lastValueFrom, map } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';
import { concatAllBasket, getGroupListData, getUserListData } from '@core/_utils/tools.utils';
import { IndexedDbService } from '@service/indexeddb.service';
import { Tools } from '@service/tools';

@Component({
    selector: 'app-list-supervbase',
    templateUrl: './list-supervbase.component.html',
    styleUrls: ['./list-supervbase.component.scss'],
})
export class ListSupervBaseComponent extends TabPanelHandler implements OnInit {
    public value = true;
    public itemConfirm: ItemConfirmComponent;
    public dataList = [];
    public groupList = [];
    public userList = [];
    public basketList = [];

    protected _isInRangeTimeout: any;

    public listColumns = [];

    @ViewChildren('p-tabPanel:not(:first-child)')
    public itemChildren: QueryList<any>;

    @ViewChild('dt')
    public dataTable: Table;
    public blockEvent = false;

    @Input()
    public entities: Array<any> = [];

    constructor(
        private api: ApiV6Service,
        public tools: Tools,
        private indexedDbService: IndexedDbService,
        public menu: MenuServiceInt,
        protected _messageService: MessagesService,
        public confirmationService: ConfirmationService,
        private commonService: CommonService,
        protected translate: TranslateService
    ) {
        super(translate);
        this.menu.display = true;
    }

    ngOnInit() {
        this.itemConfirm = new ItemConfirmComponent(this.confirmationService);
        this.listColumns = [
            { header: this.translate.instant('Name'), field: 'name' },
            { header: this.translate.instant('Col_Inti_1'), field: 'label' },
        ];
        this.findAll();
        this.commonService.checkReset();
    }

    setFilteredList(event) {}

    private async findAll() {
        let wRes: any = {};
        let wBskList: any;
        try {
            wRes.data = await lastValueFrom(this.readData());
            this.dataList = wRes.data.getSupervBaseList.data.map((item) => {
                item._label = item.label;
                return item;
            });
            this.groupList = [...getGroupListData(wRes.data.getGroupList.GroupList)];
            this.userList = [...getUserListData(wRes.data.getUserList.UserList)];
            wBskList = this.tools.getBasketTransfert(wRes.data.getBasketList, null, false, null, null, null);
            this.basketList = concatAllBasket(
                wBskList.wBasketMailList,
                wBskList.wBasketCollectList,
                wBskList.wBasketPublishList,
                wBskList.wBasketActionList,
                wBskList.wBasketInputList,
                wBskList.wBasketOutputList,
                wBskList.wBasketSystemList
            );
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        }
    }

    private readData() {
        return forkJoin([
            this.api.execUrlAction('getsupervbaselist',''),
            this.api.execUrlAction('getuserlist', ''),
            this.api.execUrlAction('getgrouplist', ''),
            this.indexedDbService.getBasketList()
        ]).pipe(
            map(([getSupervBaseList, getUserList, getGroupList, getBasketList]) => {
                return { getSupervBaseList, getUserList, getGroupList, getBasketList };
            })
        );
    }

    closeTab(event) {
        this.closeTabsheet(event);
        this.index = event.index - 1;
        this.execClose(event);
    }

    validateTab(event) {
        this.dataList = this.dataList.map((item) => {
            if (item.id === event.data.id) {
                item.label = event.data.label;
                item.name = event.data.name;
                item._label = event.data.label;
                return item;
            } else {
                return item;
            }
        });
        this.dataList = [...this.dataList];
        this.closeTab(event);
    }

    addTab(event) {
        this.dataList.push(event.data);
        this.dataList = [...this.dataList];
        this.dataList = this.dataList.map((item) => {
            item._label = item.name;
            return item;
        });
        this.closeTabsheet(this._event);
        this.index = this.index - 1;
    }

    deleteTab(event) {
        this.dataList = this.dataList.filter((item) => {
            return item.id !== event.data.id;
        });
        this.dataList = [...this.dataList];
        this.closeTab(event);
    }

    cancelAdd(event) {
        this.closeTabsheet(this._event);
        this.index = this.index - 1;
    }

    handleChange($event) {
        this.index = $event.index;
    }

    confirmDelete(event) {
        this.itemConfirm.confirmAction(
            'delete',
            this.translate.instant('Confirm_DelSV', {label: event.data.name}),
            () => {
                this.delete(event);
            }
        );
    }
    
    public async delete(event) {
        let wRes: any;
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('deletesupervbase', event.data.id ));
            this.deleteTab(event);
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        }
    }

    showDetails(item) {
        item = item.data;
        if (!this.isAlreadySelected(item.id)) {
            this.addElement(item.id, item.name, item.name);
        }
    }

    sortReference(event: any): void {}
}
